import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-student-calendar',
    templateUrl: './student-calendar.component.html',
    styleUrls: ['./student-calendar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StudentCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
